import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const legacyAdminSchema = z.object({
  tab: z.string().optional(),
  subtab: z.string().optional(),
}).passthrough()

export const Route = createFileRoute('/_authenticated/admin/')({
  validateSearch: legacyAdminSchema,
  beforeLoad: ({ search }) => {
    const { tab, subtab, ...rest } = search as Record<string, unknown>

    // Handle two-level legacy URLs: ?tab=system&subtab=rbac → /admin/system/rbac
    if (typeof tab === 'string' && tab === 'system' && typeof subtab === 'string' && subtab) {
      throw redirect({
        to: `/admin/system/${subtab}`,
        search: rest as Record<string, string>,
      })
    }

    // Handle single-level legacy URLs: ?tab=team → /admin/team
    const segment = typeof tab === 'string' && tab ? tab : 'team'
    throw redirect({
      to: `/admin/${segment}`,
      search: rest as Record<string, string>,
    })
  },
})
